const formatError = (error?: string | string[]) => {
    if (error && Array.isArray(error)) {
        return error.join(', ');
    }
    return error;
};

export default formatError;
